import { useState } from "react";
import { CreditCard, Smartphone } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { inr } from "@/lib/api";

export default function RazorpayMock({ open, amount, onPay, onClose, busy }) {
  const [method, setMethod] = useState("upi");
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="razorpay-mock-modal" className="max-w-sm bg-white">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>Razorpay <span className="ml-1 rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800">TEST · MOCKED</span></span>
          </DialogTitle>
          <DialogDescription>Click, Print & Doodle · {inr(amount)}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {[["upi", "UPI", Smartphone], ["card", "Card", CreditCard]].map(([k, l, I]) => (
            <button key={k} data-testid={`razorpay-method-${k}`} onClick={() => setMethod(k)}
              className={`flex w-full items-center gap-3 rounded-lg border px-4 py-3 text-sm ${method === k ? "border-[#3395FF] bg-blue-50" : "border-slate-200"}`}>
              <I className="h-4 w-4" />{l}
            </button>
          ))}
        </div>
        <button data-testid="razorpay-mock-pay-btn" disabled={busy} onClick={onPay} className="mt-2 w-full rounded-lg bg-[#3395FF] py-3 text-sm font-semibold text-white disabled:opacity-60">
          {busy ? "Processing…" : `Pay ${inr(amount)}`}
        </button>
        <p className="text-center text-[11px] text-slate-500">Simulated payment — no money is charged.</p>
      </DialogContent>
    </Dialog>
  );
}
